export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">联系我们</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            有任何意见、建议或合作意向，欢迎通过以下方式与我们取得联系
          </p>
        </div>

        <div className="max-w-lg mx-auto">
          <div className="bg-background-50 rounded-lg border border-background-200/60 p-6 md:p-8">
            <div className="flex flex-col items-center gap-6">
              <div className="w-16 h-16 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                <i className="ri-mail-send-line text-3xl"></i>
              </div>
              <div className="text-center">
                <h3 className="text-base font-semibold text-foreground-900 mb-2">投稿与咨询</h3>
                <p className="text-sm text-foreground-500 leading-relaxed mb-4">
                  如果您有动漫相关资讯、原创内容或合作需求，欢迎发送邮件至我们的官方邮箱，我们将在24小时内回复。
                </p>
                <a
                  href="#contact"
                  className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 text-background-50 dark:text-foreground-950 font-medium text-sm rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-mail-line"></i>
                  发送邮件
                </a>
              </div>
              <div className="w-full pt-4 border-t border-background-200/60">
                <div className="flex flex-wrap justify-center gap-6 text-xs text-foreground-400">
                  <span>服务时间：每日 9:00 - 22:00</span>
                  <span>响应时效：24小时内</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}